var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTaxi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#000000;stroke-miterlimit:10;}\r\n\t.st1{fill:none;stroke:#000000;stroke-linecap:round;stroke-linejoin:bevel;stroke-miterlimit:10;}\r\n\t.st2{fill:none;stroke:#000000;stroke-linecap:round;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.8,19H5.3c-0.8,0-1.4-0.6-1.4-1.4v-5.1c0-0.8,0.6-1.4,1.4-1.4h13.5c0.8,0,1.4,0.6,1.4,1.4v5.1 C20.1,18.3,19.5,19,18.8,19z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3.8,17.6v2.6c0,0.3,0.3,0.6,0.6,0.6h0.5c0.3,0,0.6-0.3,0.6-0.6V19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.1,17.6v2.6c0,0.3-0.3,0.6-0.6,0.6H19c-0.3-0.1-0.5-0.3-0.5-0.6V19"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 10.2,
    y1: 16,
    x2: 13.9,
    y2: 16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 14.2,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 14.2,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M4.5,11.3L5.7,7C6,6,6.8,5.2,8,5.2h8.2c1,0,2,0.7,2.3,1.7l1.2,4.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.7,5.2L10,3.9c0.1-0.5,0.5-0.8,1-0.8h2.2c0.5,0,0.9,0.3,1,0.8l0.2,1.3"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 5,
    y1: 9,
    x2: 3.7,
    y2: 9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 20.4,
    y1: 9,
    x2: 19,
    y2: 9
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.7,
    cy: 19.8,
    rx: 0.8,
    ry: 1.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.3,
    cy: 19.7,
    rx: 0.7,
    ry: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaxi);
export default __webpack_public_path__ + "static/media/taxi.febf5ac07c4a9406502dd39331c2f636.svg";
export { ForwardRef as ReactComponent };